import React from 'react';
import { Title, ChannelVal, DateFontStyle, EachRow, FemaleDataBar, GraphBarContainer, GraphHeader, GraphLabel, GraphMainWrapper, GraphWrapper, MaleDataBar, ParagraphBold, ParagraphNormal, PercentageBar, Star, SummaryWrapper, UnKnownDataBar, TopicAwithStarDiv, TitleHeaderWrapper } from '../../Pages/CompetitiveIntelligence/ViewCompetitive.styled';
import { emoji_anger, emoji_disgust, emoji_fear, emoji_joy, emoji_neutral, emoji_sadness, emoji_surprise, FacebookLogoSmall, FlipkartIconSmall, InstagramIconSmall, InstagramLogo, StarIcon, TwitterIconSmall, X_LOGO } from '../../Common/SvgIcon/CommonSvgIcons';
import { formatNumber } from '../../Common/TendsInUserActivity/LineChart';

import Flip from '../../assests/images/flipkart.png'
import YoutubeImg from '../../assests/images/youtubeImg.png'
import Insta from '../../assests/images/Instagram.png'

const PercentageBarComp = ({ theme, title, data, multiplier, compData, summary1 = '', summary2 = '' }) => {
    let emojiList = {
        neutral: emoji_neutral,
        surprise: emoji_surprise,
        joy: emoji_joy,
        fear: emoji_fear,
        sadness: emoji_sadness,
        anger: emoji_anger,
        disgust: emoji_disgust,
        length: 2,
    };

    return (
        <GraphMainWrapper title={title} className="pdf-page" style={{
            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
        }}>
            <GraphWrapper title={title}>
                <GraphHeader theme={theme}>
                    {/* Gender Demographics */}
                    {
                        title === 'Emotions' ?
                            <TitleHeaderWrapper >

                                <Title theme={theme}>{title}</Title>
                                <GraphLabel theme={theme}>
                                    <div>
                                        <span className='topic1'></span> <span style={{ marginRight: '2px' }}>{compData?.[0]?.channel && compData?.[0]?.channel == 'twitter' ? X_LOGO : compData?.[0]?.channel == 'instagram' ?

                                            <> <img src={Insta} style={{ width: '15px', marginTop: '0px' }} /></> : 
                                            compData?.[1]?.channel == 'youtube' ? 
                                        <> <img src={YoutubeImg} style={{ width: '15px', marginTop: '0px' }} /></> :
                                            compData?.[0]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[0]?.channel == 'flipkart' ?
                                                <> <img src={Flip} style={{ width: '18px', marginTop: '-3px' }} /></> : ''}</span>{compData?.[0]?.chatter_topic_title ? `${compData?.[0]?.chatter_topic_title}` : ''}
                                    </div>
                                    <div>
                                        {/* {compData?.[0]?.channel ? compData?.[0]?.channel == 'twitter' ? X_LOGO : compData?.[0]?.channel : ''} */}
                                        {/* {compData?.[1]?.channel ? compData?.[1]?.channel == 'twitter' ? X_LOGO : compData?.[1]?.channel : ''}  */}
                                        <span className='topicB'></span><span style={{ marginRight: '2px' }}>{compData?.[1]?.channel && compData?.[1]?.channel == 'twitter' ? X_LOGO : 
                                        compData?.[1]?.channel == 'youtube' ? 
                                        <> <img src={YoutubeImg} style={{ width: '15px', marginTop: '0px' }} /></> :
                                        compData?.[1]?.channel == 'instagram' ?
                                            <> <img src={Insta} style={{ width: '15px', marginTop: '0px' }} /></> : compData?.[1]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[1]?.channel == 'flipkart' ?
                                                <> <img src={Flip} style={{ width: '18px', marginTop: '-3px' }} /></> : ''}</span>{compData?.[1]?.chatter_topic_title ? `${compData?.[1]?.chatter_topic_title}` : ''}
                                    </div>
                                </GraphLabel>
                            </TitleHeaderWrapper >
                            :
                            <Title theme={theme}>{title}</Title>

                    }
                </GraphHeader>
                {
                    // title === 'Gender Demographics' ?
                    //     <GraphLabel>
                    //         <div>
                    //             <span className='male'></span>Male
                    //         </div>
                    //         <div>
                    //             <span className='female'></span>Female
                    //         </div>
                    //         <div>
                    //             <span className='unknown'></span>Unknown
                    //         </div>
                    //     </GraphLabel>
                    //     :
                    title === 'Average Rating' || title === 'Engagement Metrics' || title === 'Sentiments' || title === 'Gender Demographics' ?
                        <GraphLabel theme={theme}>
                            <div>
                                <span className='topic1'></span> <span style={{ marginRight: '5px',alignItems:compData?.[0]?.channel == 'youtube' && 'flex-end',display:compData?.[0]?.channel == 'youtube' && 'flex' }}>{compData?.[0]?.channel && compData?.[0]?.channel == 'twitter' ? X_LOGO : compData?.[0]?.channel == 'instagram' ? <> <img src={Insta} style={{ width: '15px', marginTop: '0px' }} /></> : compData?.[0]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[0]?.channel == 'flipkart' ? <> <img src={Flip} style={{ width: '18px', marginTop: '-3px' }} /></> : compData?.[0]?.channel == 'youtube' ? 
                                <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> : ''}</span> {compData?.[0]?.chatter_topic_title ? `${compData?.[0]?.chatter_topic_title}` : ''}
                            </div>
                            <div>
                                <span className='topicB'></span> <span style={{ marginRight: '5px',alignItems:compData?.[1]?.channel == 'youtube' && 'flex-end',display:compData?.[1]?.channel == 'youtube' && 'flex' }}>{compData?.[1]?.channel && compData?.[1]?.channel == 'twitter' ? X_LOGO : compData?.[1]?.channel == 'instagram' ? <> <img src={Insta} style={{ width: '15px', marginTop: '0px' }} /></> :
                                compData?.[1]?.channel == 'youtube' ? 
                                <> <img src={YoutubeImg} style={{ width: '19px', marginTop: '0px' }} /></> :
                                compData?.[1]?.channel == 'facebook' ? FacebookLogoSmall : compData?.[1]?.channel == 'flipkart' ? <> <img src={Flip} style={{ width: '18px', marginTop: '-3px' }} /></> : ''}</span> {compData?.[1]?.chatter_topic_title ? `${compData?.[1]?.chatter_topic_title}` : ''}
                            </div>
                        </GraphLabel>
                        // {compData?.[0]?.channel ? compData?.[0]?.channel == 'twitter' ? X_LOGO : compData?.[0]?.channel : ''} {compData?.[1]?.channel ? compData?.[1]?.channel == 'twitter' ? X_LOGO : compData?.[1]?.channel : ''}
                        :
                        // title === 'Sentiments' ?
                        //     <GraphLabel>
                        //         <div>
                        //             <span className='positive'></span>Positive
                        //         </div>
                        //         <div>
                        //             <span className='negative'></span>Negative
                        //         </div>
                        //         <div>
                        //             <span className='neutral'></span>Neutral
                        //         </div>
                        //     </GraphLabel>
                        //     :
                        <GraphLabel theme={theme}>
                        </GraphLabel>
                }

                <GraphBarContainer style={{ width: title === 'Emotions' ? '90%' : '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                    {data?.map((el) => (
                        <EachRow key={el.label}>
                            {/* {el.label} */}
                            {
                                title === 'Emotions' ?
                                    <div>
                                        <div>
                                            {
                                                emojiList.length > 0 ? (
                                                    <Star theme={theme} className={'barLabel'} style={{ display: 'flex', minWidth: '100px', justifyContent: 'flex-start' }}>
                                                        <div data-testid='emoji' className='emoji'>
                                                            {emojiList[el.label?.toLowerCase()]}
                                                        </div>
                                                        {el.label}
                                                    </Star>
                                                )
                                                    : <></>
                                            }
                                        </div>
                                        {/* <Star>{el.label}</Star> */}
                                    </div>
                                    :
                                    <div>
                                        {
                                            title === 'Gender Demographics' || title === 'Sentiments' ?

                                                <ChannelVal>{el.channel}</ChannelVal>
                                                :
                                                <></>
                                        }
                                        <Star theme={theme}>{el.label}</Star>
                                    </div>
                            }




                            {
                                title === 'Gender Demographics' ?

                                    // <PercentageBar>
                                    //     <MaleDataBar width={Math.floor(el.male * multiplier)} background='rgb(27, 175, 246)'>{el.male}</MaleDataBar>
                                    //     <FemaleDataBar width={Math.floor(el.female * multiplier)} background={'rgb(234, 170, 189)'} >{el.female}</FemaleDataBar>
                                    //     <UnKnownDataBar width={Math.floor(el.unknown * multiplier)} background='rgb(218, 217, 219)'>{el.unknown}</UnKnownDataBar>
                                    //     {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                    // </PercentageBar>
                                    <PercentageBar>
                                        <MaleDataBar theme={theme} width={Math.floor(el.topicA * multiplier)} background='rgba(161, 216, 35, 1)'>
                                            <TopicAwithStarDiv theme={theme}  >
                                                {el.topicA}%
                                            </TopicAwithStarDiv>
                                        </MaleDataBar>
                                        <FemaleDataBar theme={theme} width={Math.floor(el.topicB * multiplier)} background='rgba(45, 137, 85, 1)'>
                                            <TopicAwithStarDiv theme={theme}>
                                                {el.topicB}%
                                            </TopicAwithStarDiv></FemaleDataBar>
                                        {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                    </PercentageBar>
                                    :
                                    title === 'Sentiments' ?
                                        // <PercentageBar>
                                        //     <MaleDataBar width={Math.floor(el.positive * multiplier)} background='rgba(118, 237, 166, 1)'>{el.positive}%</MaleDataBar>
                                        //     <FemaleDataBar width={Math.floor(el.negitive * multiplier)} background='rgba(252, 216, 126, 1)'>{el.negitive}%</FemaleDataBar>
                                        //     <UnKnownDataBar width={Math.floor(el.neutral * multiplier)} background='rgba(253, 127, 120, 1)'>{el.neutral}%</UnKnownDataBar>
                                        //     {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                        // </PercentageBar>
                                        <PercentageBar>
                                            <MaleDataBar theme={theme} width={Math.floor(el.topicA * multiplier)} background='rgba(161, 216, 35, 1)'>
                                                <TopicAwithStarDiv theme={theme} >
                                                    {el.topicA}%
                                                </TopicAwithStarDiv>
                                            </MaleDataBar>
                                            <FemaleDataBar theme={theme} width={Math.floor(el.topicB * multiplier)} background='rgba(45, 137, 85, 1)'>
                                                <TopicAwithStarDiv theme={theme}>
                                                    {el.topicB}%
                                                </TopicAwithStarDiv></FemaleDataBar>
                                            {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                        </PercentageBar>
                                        :
                                        title === 'Emotions' ?

                                            <PercentageBar theme={theme}>
                                                <MaleDataBar theme={theme} width={Math.floor(el.topicA * multiplier)} background='rgba(161, 216, 35, 1)'>{el.topicA}%</MaleDataBar>

                                                <FemaleDataBar theme={theme} width={Math.floor(el.topicB * multiplier)} background='rgba(45, 137, 85, 1)'>{el.topicB}%</FemaleDataBar>
                                                {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                            </PercentageBar>
                                            :
                                            title === 'Average Rating' ?
                                                <PercentageBar>
                                                    <MaleDataBar theme={theme} width={Math.floor(el.topicA * multiplier)} background='rgba(161, 216, 35, 1)'>
                                                        {/* <MaleDataBar width={Math.floor(el.topicA * multiplier)} background='rgba(54, 162, 235, 1)'> */}
                                                        <TopicAwithStarDiv theme={theme} >
                                                            {el.topicA}{StarIcon}
                                                        </TopicAwithStarDiv>
                                                    </MaleDataBar>
                                                    <FemaleDataBar theme={theme} width={Math.floor(el.topicB * multiplier)} background='rgba(45, 137, 85, 1)'>
                                                        {/* <FemaleDataBar width={Math.floor(el.topicB * multiplier)} background='rgba(255, 99, 132, 1)'> */}
                                                        <TopicAwithStarDiv theme={theme}>
                                                            {el.topicB}{StarIcon}
                                                        </TopicAwithStarDiv></FemaleDataBar>
                                                    {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                                </PercentageBar>
                                                :
                                                title === 'Engagement Metrics' ?
                                                    <PercentageBar>
                                                        <MaleDataBar theme={theme} width={Math.floor(el.topicA * multiplier)} background='rgba(161, 216, 35, 1)'>
                                                            <TopicAwithStarDiv theme={theme} >
                                                                {formatNumber(el?.topicA) || 0}
                                                            </TopicAwithStarDiv>
                                                        </MaleDataBar>
                                                        <FemaleDataBar theme={theme} width={Math.floor(el.topicB * multiplier)} background='rgba(45, 137, 85, 1)'>
                                                            <TopicAwithStarDiv theme={theme}>
                                                                {formatNumber(el?.topicB) || 0}
                                                            </TopicAwithStarDiv></FemaleDataBar>
                                                        {/* <NonVerifiedBar>{el.topicB}</NonVerifiedBar> */}
                                                    </PercentageBar>
                                                    :

                                                    <PercentageBar>No Data</ PercentageBar>
                            }

                        </EachRow>
                    ))}
                </GraphBarContainer>


                {/* <DateFontStyle>
                This data is observed from {compData?.[0]?.user_start_date || ''} to {compData?.[0]?.user_end_date || ''}
                </DateFontStyle> */}
            </GraphWrapper>
            {
                title === 'Emotions' ?

                    <SummaryWrapper>
                        <ParagraphBold theme={theme}>
                            {title === 'Emotions' ? `${compData?.[0]?.chatter_topic_title} :` : data[0]?.label && `${data[0]?.label} :`} <ParagraphNormal theme={theme}>{summary1}</ParagraphNormal>
                        </ParagraphBold>
                        <ParagraphBold theme={theme}>
                            {title === 'Emotions' ? `${compData?.[1]?.chatter_topic_title} :` : data[1]?.label && `${data[1]?.label} :`} <ParagraphNormal theme={theme}>{summary2}</ParagraphNormal>
                        </ParagraphBold>
                    </SummaryWrapper>
                    :
                    <></>
            }
        </GraphMainWrapper>
    );
};


export default PercentageBarComp;